export default __webpack_public_path__ + "assets/models/55c910aec33d6d993b855a71a8768cc2.glb";